import { IRadioButtonItem } from "components/Filters/RadioButtonsFilter/RadioButtonsFilter";

export const MIN_SLIDER_FILTER_VALUE = 0;
export const MAX_SLIDER_FILTER_VALUE = 90;
export const MIN_DISTANCE = 1;
export const initialSliderFilterValues = [
  MIN_SLIDER_FILTER_VALUE,
  MAX_SLIDER_FILTER_VALUE
];

// Data for openDates, assignedDates, completeDates, closedDates, canceledDates filters
enum EDatesLabels {
  ALL_DATES = "All Dates",
  TODAY = "Today",
  PAST_7_DAYS = "Past 7 Days",
  PAST_30_DAYS = "Past 30 Days",
  PAST_60_DAYS = "Past 60 Days",
  PAST_90_DAYS = "Past 90 Days"
}

export const dates: IRadioButtonItem[] = [
  {
    label: EDatesLabels.ALL_DATES,
    value: 0
  },
  {
    label: EDatesLabels.TODAY,
    value: 1
  },
  {
    label: EDatesLabels.PAST_7_DAYS,
    value: 7
  },
  {
    label: EDatesLabels.PAST_30_DAYS,
    value: 30
  },
  {
    label: EDatesLabels.PAST_60_DAYS,
    value: 60
  },
  {
    label: EDatesLabels.PAST_90_DAYS,
    value: 90
  }
];

// Reporters filter
export const reportersTitles = {
  filterSummaryTitle: "Reporter",
  searchTitle: "Search Reporters",
  textFieldLabel: "Reporter Names"
};
